import { renderEmail } from "react-html-email";
import { BaseEmailTemplate2 } from "../../../Base/views/BaseEmailTemplate";
import {
  BASE_URL,
  HRMS_FINANCE_API_URL,
} from "../../../../Constants/baseConstant";
import axiosInstance from "../../../../../axiosInstance";
import { getSessionData } from "../../../Base/helper/baseHelper";
import { getImageSignedUrl } from "../../../Base/helper/baseFunctions";

export const ExpenseRequestContent = ({
  employeeName,
  managerName,
  category,
  subCategory,
  claimedAmount,
  region,
  date,
  status,
}) => {
  const newSubmittion = status === "Submitted";
  return (
    <table
      width="100%"
      border="0"
      align="center"
      cellPadding="0"
      cellSpacing="0"
      style={{
        maxWidth: "1070px",
        borderRadius: "8px",
        textAlign: "center",
        boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.06)",
        backgroundColor: "rgba(255, 255, 255, 0.6)",
      }}
    >
      <tr style={{ textAlign: "left" }}>
        <td style={{ padding: "20px 45px 0" }}>
          <span
            style={{ color: "#455056", fontSize: "15px", lineHeight: "24px" }}
          >
            Dear {managerName},
          </span>
        </td>
      </tr>

      <tr>
        <td style={{ height: "20px" }}>&nbsp;</td>
      </tr>

      <tr>
        <td style={{ padding: "0px 45px", textAlign: "left" }}>
          <span
            style={{ color: "#455056", fontSize: "15px", lineHeight: "24px" }}
          >
            <span style={{ fontWeight: "bold" }}>{employeeName}</span>{" "}
            {newSubmittion
              ? "has submitted a new expense request."
              : "has updated an existing expense request."}
          </span>
          <br />
          <br />
          <span
            style={{ color: "#455056", fontSize: "15px", lineHeight: "24px" }}
          >
            <strong>Category:</strong> {category}
            <br />
            <strong>Subcategory:</strong> {subCategory}
            <br />
            <strong>Claimed Date:</strong> {date}
            <br />
            <strong>Claimed Amount:</strong> ₹
            {Number(claimedAmount)?.toFixed(2)}
          </span>
          <br />
          <br />
          <span
            style={{ color: "#455056", fontSize: "15px", lineHeight: "24px" }}
          >
            Please review and take action by clicking the button below.
          </span>
        </td>
      </tr>

      <tr>
        <td style={{ height: "30px" }}>&nbsp;</td>
      </tr>

      <tr>
        <td style={{ textAlign: "center" }}>
          <a
            href={`${BASE_URL}/${region}/signup`}
            style={{
              background: "#20e277",
              textDecoration: "none !important",
              fontWeight: 500,
              color: "#fff",
              textTransform: "uppercase",
              fontSize: "14px",
              padding: "10px 24px",
              borderRadius: "50px",
            }}
          >
            View Expense
          </a>
        </td>
      </tr>

      <tr>
        <td style={{ height: "30px" }}>&nbsp;</td>
      </tr>
    </table>
  );
};

export const ExpenseApproveRejectContent = ({
  employeeName,
  category,
  subCategory,
  claimedAmount,
  approverAmount,
  region,
  status, // new prop: "Approved" or "Rejected"
}) => {
  const isApproved = status === "Approved";

  return (
    <table
      width="100%"
      border="0"
      align="center"
      cellPadding="0"
      cellSpacing="0"
      style={{
        maxWidth: "1070px",
        borderRadius: "8px",
        textAlign: "center",
        boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.06)",
        backgroundColor: "rgba(255, 255, 255, 0.6)",
      }}
    >
      <tr style={{ textAlign: "left" }}>
        <td style={{ padding: "20px 45px 0" }}>
          <span
            style={{ color: "#455056", fontSize: "15px", lineHeight: "24px" }}
          >
            Dear {employeeName},
          </span>
        </td>
      </tr>

      <tr>
        <td style={{ height: "20px" }}>&nbsp;</td>
      </tr>

      <tr>
        <td style={{ padding: "0px 45px", textAlign: "left" }}>
          <span
            style={{ color: "#455056", fontSize: "15px", lineHeight: "24px" }}
          >
            Your expense request has been{" "}
            <strong style={{ color: isApproved ? "#20e277" : "#f44336" }}>
              {status}
            </strong>
            .
          </span>
          <br />
          <br />
          <span
            style={{ color: "#455056", fontSize: "15px", lineHeight: "24px" }}
          >
            <strong>Category:</strong> {category}
            <br />
            <strong>Subcategory:</strong> {subCategory}
            <br />
            <strong>Claimed Amount:</strong> ₹{Number(claimedAmount).toFixed(2)}
            <br />
            {isApproved && (
              <>
                <strong>Approved Amount:</strong> ₹
                {Number(approverAmount).toFixed(2)}
              </>
            )}
          </span>
          <br />
          <br />
          <span
            style={{ color: "#455056", fontSize: "15px", lineHeight: "24px" }}
          >
            You can view the expense status by clicking the button below.
          </span>
        </td>
      </tr>

      <tr>
        <td style={{ height: "30px" }}>&nbsp;</td>
      </tr>

      <tr>
        <td style={{ textAlign: "center" }}>
          <a
            href={`${BASE_URL}/${region}/signup`}
            style={{
              background: isApproved ? "#20e277" : "#f44336",
              textDecoration: "none !important",
              fontWeight: 500,
              color: "#fff",
              textTransform: "uppercase",
              fontSize: "14px",
              padding: "10px 24px",
              borderRadius: "50px",
            }}
          >
            View Expense
          </a>
        </td>
      </tr>

      <tr>
        <td style={{ height: "30px" }}>&nbsp;</td>
      </tr>
    </table>
  );
};

const componenet = {
  Submitted: ExpenseRequestContent,
  ReSubmitted: ExpenseRequestContent,
  Approved: ExpenseApproveRejectContent,
  Rejected: ExpenseApproveRejectContent,
};

// Email
export const sendExpenseEmailHelper = async (params) => {
  const region = getSessionData({ key: "region" });
  var Component = componenet[params?.status];
  const company_logo = await getImageSignedUrl(params?.company_logo);
  return await axiosInstance(`/finance/ancillary/payroll/send-mail`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      to: params?.toEmail,
      subject:
        params?.status === "Submitted"
          ? `New Expense Request Submitted by ${params?.employeeName}`
          : params?.status === "ReSubmitted"
          ? `Expense Request Updated by ${params?.employeeName}`
          : `Expense Request ${params?.status}`,
      email_content: renderEmail(
        <BaseEmailTemplate2 company_logo={company_logo}>
          <Component
            status={params?.status}
            employeeName={params?.employeeName}
            managerName={params?.managerName}
            category={params?.category}
            subCategory={params?.subCategory}
            date={params?.date}
            claimedAmount={params?.claimedAmount}
            approverAmount={params?.approverAmount}
            region={region}
          />
        </BaseEmailTemplate2>
      ),
    },
  })
    .then((res) => {
      return {
        message: "Email Sent Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      return {
        message: "Unable to Send Email",
        hasError: true,
        data: err?.response?.data,
      };
    });
};
